/** @format */

export const useAppModalSelector = (state) => state.ui.useAppModal;
export const extraMeetupModalSelector = (state) => state.ui.extraMeetupModal;
export const alertModalSeletor = (state) => state.ui.alertModal;
export const shareModalSelector = (state) => state.ui.shareModal;
export const rightSidebarSelector = (state) => state.ui.rightSidebar;
export const profileModifyModalSelector = (state) =>
	state.ui.profileModifyModal;
